import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode'
import './PaymentResult.css';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isVerifying, setIsVerifying] = useState(true);
  const [loggedIn, setLoggedIn] = useState(false);
  const [orderId, setOrderId] = useState("")

  useEffect(() => {
    // Let the registration page replace the payment iframe with its own
    // success screen and login button. Other checkout flows use the top-level
    // success page after the short acknowledgement window.
    if (window.self !== window.top) {
      let handledByParent = false;
      const handleParentAcknowledgement = (event) => {
        if (
          event.origin === window.location.origin
          && event.data?.type === 'SEEDXPERT_PAYMENT_SUCCESS_ACK'
        ) {
          handledByParent = true;
        }
      };

      window.addEventListener('message', handleParentAcknowledgement);
      window.top.postMessage(
        { type: 'SEEDXPERT_PAYMENT_SUCCESS' },
        window.location.origin
      );

      const fallbackTimer = setTimeout(() => {
        if (!handledByParent) window.top.location.replace(window.location.href);
      }, 1000);

      return () => {
        clearTimeout(fallbackTimer);
        window.removeEventListener('message', handleParentAcknowledgement);
      };
    }

    getOrderId();
    checkIsLoggedIn();
    setTimeout(() => {
      setIsVerifying(false);
    }, 2000);
  }, []);

  const handleContinue = () => {
    navigate('/landing');
  };

  function checkIsLoggedIn() {
    const token = localStorage.getItem('userToken');
    if (token) {
      const decoded = jwtDecode(token);
      const now = Math.floor(Date.now() / 1000);
      if (now < decoded.exp) {
        setLoggedIn(true);
      }
    }
  }

  function getOrderId() {
    const oid = localStorage.getItem('oid');
    if (oid) {
      const item = JSON.parse(oid);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        // Süresi dolmuşsa sil
        localStorage.removeItem("oid");
        return;
      }

      setOrderId(item.value);
    }
  }



  if (isVerifying) {
    return (
      <div className="payment-result-container">
        <div className="payment-result-content">
          <div className="loading-section">
            <div className="loading-spinner-large"></div>
            <h2>Ödemeniz doğrulanıyor...</h2>
            <p>Lütfen bekleyiniz, işleminiz kontrol ediliyor.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="payment-result-container">
      <div className="payment-result-content">
        <div className="success-section">
          <div className="success-icon">
            <i className="fas fa-check-circle"></i>
          </div>
          <h1>Ödeme Başarılı!</h1>
          <p>Teşekkürler! Ödemeniz başarıyla tamamlandı.</p>

          <div className="success-details">
            <div className="detail-item">
              <span className="detail-label">Sipariş ID:</span>
              <span className="detail-value">{orderId || 'N/A'}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Durum:</span>
              <span className="detail-value success-status">Tamamlandı</span>
            </div>
          </div>

          <div className="success-message">
            <h3>Ne olacak şimdi?</h3>
            <ul>
              <li>Rapor haklarınız hesabınıza tanımlandı</li>
              <li>Artık yeni değerleme raporları oluşturabilirsiniz</li>
              <li>Dashboard'a giderek işlemlerinizi görüntüleyebilirsiniz</li>
            </ul>
          </div>

          <div className="action-buttons">
            {
              loggedIn ?
                <button className="primary-btn" onClick={handleContinue}>
                  Dashboard'a Git
                </button> :
                <button className="secondary-btn" onClick={() => navigate('/')}>
                  Giriş Yap
                </button>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
